import React from 'react';
import { ProductManager } from '../components/ProductManager';

export const Products: React.FC = () => {
  return <ProductManager />;
};
